import * as React from 'react';

import type { Event } from './event';

export const useCustomEventDispatch = <T>(event: Event) => {
  return React.useCallback(
    (detail?: T) =>
      window.dispatchEvent(
        new CustomEvent(event, {
          detail,
        })
      ),
    [event]
  );
};
